import { StringInputViewModel, ValueFormField } from '@sitecore-jss/sitecore-jss-forms';
import { ValueFieldProps, Label, FieldChangeCallback } from '@sitecore-jss/sitecore-jss-react-forms';
import { FC, Fragment } from 'react';

import { FieldValidationErrors } from '../CustomFields/FieldValidationErrors';
import { getFormFieldAriaProps } from '../Functions/FormFieldAriaProps';

/**
 * Overrides the built-in Sitecore forms single line text.
 * @see [Original SingleLineText Implementation](https://github.com/Sitecore/jss/blob/v22.10.0/packages/sitecore-jss-react-forms/src/components/field-templates/single-line-text.tsx)
 *
 * Markup and functionality should be 1:1 with the exception of `getFormFieldAriaProps`.
 *
 * @param props - SingleLineText properties.
 * @returns A single line text.
 */
export const BaseSingleLineText: FC<ValueFieldProps<StringInputViewModel>> = (props) => {
  const { errors, field, onChange, tracker, value } = props;

  return (
    <Fragment>
      <Label {...props} />
      <input
        type="text"
        className={field.model.cssClass}
        id={field.valueField.id}
        name={field.valueField.name}
        value={value}
        maxLength={field.model.maxLength}
        placeholder={field.model.placeholderText}
        onChange={(e) => handleOnChange(field, e.target.value, onChange)}
        onFocus={() => tracker.onFocusField(field, value)}
        onBlur={() => tracker.onBlurField(field, value, errors)}
        {...getFormFieldAriaProps(field, errors)}
      />
      <FieldValidationErrors {...props} />
    </Fragment>
  );
};

function handleOnChange(field: ValueFormField, fieldValue: string, callback: FieldChangeCallback) {
  const errorMessages = [];
  let valid = true;

  if (field.model.required && !fieldValue) {
    valid = false;
    errorMessages.push(`${field.model.title} is required`);
  }

  callback(field.valueField.name, fieldValue, valid, errorMessages);
}
